import { Button, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutGenericColorPicker extends Layout {
    buttonClearEvenColor: Button;
    buttonColorPicker: Button;
    labelProfileColor: Label;
    panelColorDisplay: Panel;
    panelColorSelector: Panel;
}
